const { BookingCommandConnector } = require('./BookingCommandConnector');
const { BookingHistoryServiceConnector } = require('./BookingHistoryServiceConnector');
const { BookingEtaConnector } = require('./BookingEtaConnector');
const { BookingQueryConnector } = require('./BookingQueryConnector');
const { EmployeeGroupServiceConnector } = require('./EmployeeGroupServiceConnector');
const { OfferServiceConnector } = require('./OfferServiceConnector');
const { Ic2BookingServiceConnector } = require('./Ic2BookingServiceConnector');
const { FareEstimatorConnector } = require('./FareEstimatorConnector');
const { PaymentMethodCommandConnector } = require('./PaymentMethodCommandConnector');
const { RatingCommandConnector } = require('./RatingCommandConnector');
const { RatingQueryConnector } = require('./RatingQueryConnector');
const { ReceiptServiceConnector } = require('./ReceiptServiceConnector');
const { ReverseGeocoderServiceConnector } = require('./ReverseGeocoderServiceConnector');
const { SuggestionServiceConnector } = require('./SuggestionServiceConnector');
const { UserServiceConnector } = require('./UserServiceConnector');
const { CustomerConfigurationServiceConnector } = require('./CustomerConfigurationServiceConnector');
const { FavouriteAddressConnector } = require('./FavouriteAddressConnector');

module.exports = {
  BookingCommandConnector,
  BookingEtaConnector,
  BookingHistoryServiceConnector,
  BookingQueryConnector,
  EmployeeGroupServiceConnector,
  OfferServiceConnector,
  Ic2BookingServiceConnector,
  FareEstimatorConnector,
  PaymentMethodCommandConnector,
  RatingCommandConnector,
  RatingQueryConnector,
  ReceiptServiceConnector,
  ReverseGeocoderServiceConnector,
  SuggestionServiceConnector,
  UserServiceConnector,
  CustomerConfigurationServiceConnector,
  FavouriteAddressConnector,
};
